module.exports = __webpack_public_path__ + "img/georgia.8374b1d0.svg";